import { FC } from "react";
import { useTranslation } from "react-i18next";
import ProblemCard from "@/components/ui/problem-card";
import { useComparisonMode } from "./hooks/useComparisonMode";
import { ProblemListProps } from "./types";

export const ProblemList: FC<ProblemListProps> = ({
  isMainPanel,
  totalCaseCount,
  isComparisionMode,
  selectedCategoryPath,
  onOpenVocView,
}) => {
  const { t } = useTranslation("voiceek_ui");

  const { mainProblems, compProblems } = useComparisonMode();
  const problems = isMainPanel ? mainProblems : compProblems;

  return (
    <div className="w-full">
      <div className="w-full h-[30px] px-[10px] font-bold text-white bg-[#293d72] rounded-[5px] leading-[30px]">
        {/* 課題と打ち手のタイトル */}
        {t("analysis.categorySummary.problemsAndActions")}
      </div>

      <div className={`flex flex-col w-full mt-5 ${isComparisionMode ? "gap-2.5" : "gap-5"}`}>
        {problems.map((problem, index) => {
          return (isComparisionMode || problem.caseCount > 0) && (
            <ProblemCard
              key={`${selectedCategoryPath}-${problem.title}-${index}`}
              problem={problem}
              totalCaseCount={totalCaseCount}
              countermeasureDescription={problem.suggestion}
              openVocView={onOpenVocView}
            />
          );
        })}
      </div>
    </div>
  );
};
